// @flow

import type { State } from "@store/reducers";
import type {
  EmployeeSmsSettings,
  EmployeeSmsRule,
} from "@modules/service/reducer/employee-sms-notifications/types";
import type { HierarchyAssignment } from "@modules/service/types";
import { validateHierarchyAssignmentSchema } from "./index";
import type { PaginationType } from "@types";

export const getEmployeeSmsSettings = (state: State): ?EmployeeSmsSettings =>
  state.service.employeeSmsNotifications.settings;

export const getEmployeeSmsRulesList = (state: State): Array<EmployeeSmsRule> =>
  state.service.employeeSmsNotifications.smsRules.content;

export const getEmployeeSmsRulesPagination = (state: State): PaginationType =>
  state.service.employeeSmsNotifications.smsRules.pagination;

export const getEmployeeSmsRulesTotalElements = (state: State): number =>
  state.service.employeeSmsNotifications.smsRules.totalElements;

export const getEmployeeSmsRulesPage: (state: State) => number = state => {
  return (
    (
      ((((state || {}).service || {}).employeeSmsNotifications || {}).smsRules || {}).pagination ||
      {}
    ).pageNumber || 1
  );
};

export const getEmployeeSmsSchema = (state: State): ?Object =>
  state.service.employeeSmsNotifications.schema;

export const getEmployeeSmsCurrent = (state: State): ?EmployeeSmsRule =>
  state.service.employeeSmsNotifications.current;

export const getEmployeeSmsAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.employeeSmsNotifications.assignments;

export const isEmployeeSmsAssignmentsValid = (state: State): boolean => {
  const assignments = getEmployeeSmsAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const getShowAddEmployeeSmsRuleModal = (state: State): boolean =>
  state.service.employeeSmsNotifications.modals.showAddModal;

export const getShowEditEmployeeSmsRuleModal = (state: State): boolean =>
  state.service.employeeSmsNotifications.modals.showEditModal;

export const getShowDeleteEmployeeSmsRuleModal = (state: State): boolean =>
  state.service.employeeSmsNotifications.modals.showDeleteModal;
